import React, { useState } from 'react';
import { View, StyleSheet, ImageBackground, ActivityIndicator, Text } from 'react-native';
import { BounceLoader } from "react-spinners";
import background from "../assets/img/background.png"
import * as Animatable from 'react-native-animatable';

import Colors from '../constants/colors';
import Texts from '../constants/texts';

const LoadingTemplate = ({error}) => {

  return (
    <Animatable.View 
      duration={1000}
      animation={"fadeIn"}
      style={styles.container}>
      <ImageBackground source={background} style={styles.container}>
        <BounceLoader color={Colors.primary} size={100} margin={10}/>
      </ImageBackground>
    </Animatable.View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: '100vh',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    fontSize: 18,
    paddingTop: 10,
    color: Colors.primary
  }
});

export default LoadingTemplate;
